import React from "react";

const InvoiceTypeDropdown = ({ value, onChange }) => {
  const invoiceOptions = [
    { value: 'Installment 1', label: 'Installment 1' },
    { value: 'Installment 2', label: 'Installment 2' },
    {value:'Installment 3',label:'Installment 3'},
    {value:'Installment 4',label:'Installment 4'}

  ];

  return (
    <div>
      <label htmlFor="invoice-type" className="block text-gray-700 text-sm font-semibold mb-2">
        Milestone
      </label>
      <select
        id="invoice-type"
        name="invoiceType"
        value={value}
        onChange={onChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"

      >
        <option value="">All</option>
        {invoiceOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default InvoiceTypeDropdown;
